import React, { useEffect } from "react";
import {
    Form,
    useActionData,
    useNavigation,
    ActionFunction,
} from "react-router-dom";

import { Container, Row, Col, Card, Button, FormGroup } from "react-bootstrap";

import { alertActions } from "../../../features/alert/alertSlice";
import { useAppDispatch } from "../../../hooks/reduxHooks";
import { lostPassword } from "../../../lib/api";
import { IError } from "../../../types/shared";
import { ICredentials } from "../../../types/users";

export const action: ActionFunction = async ({ request }) => {
    const formData = await request.formData();
    const email = formData.get("email") as ICredentials["email"];

    return lostPassword(email)
        .then(response => {
            return {
                status: response.status,
                message: response.message,
            };
        })
        .catch(e => {
            return {
                status: "error",
                message: e,
            };
        });
};

const LostPassword = () => {
    const message = useActionData() as IError;
    const dispatch = useAppDispatch();

    useEffect(() => {
        message?.status &&
            (message.status === "success"
                ? dispatch(
                      alertActions.success({
                          title: "Success!",
                          text: message.message,
                          dismissible: true,
                      }),
                  )
                : dispatch(
                      alertActions.error({
                          title: "Problem encountered",
                          text: message.message,
                          dismissible: true,
                      }),
                  ));
    }, [message]);

    const navigation = useNavigation();

    return (
        <div data-testid="lostPasswordContent">
            {message?.status !== "success" && (
                <Container>
                    <Row className="justify-content-center">
                        <Col lg="6" md="9">
                            <Card className="o-hidden border-0 shadow-lg my-5">
                                <Card.Body className="p-0">
                                    <Row>
                                        <Col className="p-5 text-center">
                                            <h2 className="text-gray-900 mb-4">
                                                Recover Password
                                            </h2>

                                            <p className="text-start">
                                                Please enter your email address.
                                                <br />
                                                You will receive a link to
                                                create a new password via email.
                                            </p>
                                            <Form
                                                method="post"
                                                className="user"
                                                id="lostPassword"
                                            >
                                                <FormGroup className="form-group">
                                                    <input
                                                        type="email"
                                                        name="email"
                                                        placeholder="Enter Email Address..."
                                                        className="form-control form-control-user"
                                                        required
                                                    />
                                                </FormGroup>
                                                <Button
                                                    disabled={
                                                        navigation.state ===
                                                        "submitting"
                                                    }
                                                    variant="primary"
                                                    type="submit"
                                                >
                                                    {navigation.state ===
                                                    "submitting"
                                                        ? "Submitting..."
                                                        : "Get New Password"}
                                                </Button>
                                            </Form>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            )}
        </div>
    );
};

export default LostPassword;
